import React, { Component } from "react";
import { Row, Col, Card, CardBody, ButtonGroup, Button } from "reactstrap";
import { RevenueAnalyticsChart } from "./Charts";
import { changeTone, formatRate, formatSar } from "./format";
import "./dashboard.scss";

const RANGES = [
  { key: "today", label: "Today" },
  { key: "week", label: "Weekly" },
  { key: "month", label: "Monthly" },
];

const Change = ({ direction, percent }) => {
  const tone = changeTone(direction);
  return (
    <div className={`text-${tone.color}`}>
      <i className={`mdi ${tone.icon} font-size-14`}> </i>
      {formatRate(percent)}
    </div>
  );
};

class RevenueAnalytics extends Component {
  state = { range: "week" };

  render() {
    const revenue = this.props.revenue;
    const selected = revenue?.ranges?.[this.state.range] || {
      labels: [],
      currentName: "Current",
      previousName: "Previous",
      current: [],
      previous: [],
    };

    return (
      <React.Fragment>
        <Card>
          <CardBody>
            <div className="float-end d-none d-md-inline-block">
              <ButtonGroup className="mb-2">
                {RANGES.map((item) => (
                  <Button
                    key={item.key}
                    size="sm"
                    color="light"
                    type="button"
                    active={this.state.range === item.key}
                    onClick={() => this.setState({ range: item.key })}
                  >
                    {item.label}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
            <h4 className="card-title mb-2">Revenue Analytics</h4>
            <div id="line-column-chart" className="apex-charts" dir="ltr">
              <RevenueAnalyticsChart
                key={this.state.range}
                labels={selected.labels}
                currentName={selected.currentName}
                previousName={selected.previousName}
                current={selected.current}
                previous={selected.previous}
              />
            </div>
          </CardBody>

          <CardBody className="border-top text-center">
            <Row>
              <Col sm={4}>
                <div className="d-inline-flex">
                  <h5 className="me-2">{formatSar(revenue?.thisMonth?.amount)}</h5>
                  <Change
                    direction={revenue?.thisMonth?.direction}
                    percent={revenue?.thisMonth?.changePercent}
                  />
                </div>
                <p className="text-muted text-truncate mb-0">This month</p>
              </Col>

              <Col sm={4}>
                <div className="mt-4 mt-sm-0">
                  <p className="mb-2 text-muted text-truncate">
                    <i className="mdi mdi-circle text-primary font-size-10 me-1"></i>{" "}
                    This Year :
                  </p>
                  <div className="d-inline-flex">
                    <h5 className="mb-0 me-2">
                      {formatSar(revenue?.thisYear?.amount)}
                    </h5>
                    <Change
                      direction={revenue?.thisYear?.direction}
                      percent={revenue?.thisYear?.changePercent}
                    />
                  </div>
                </div>
              </Col>
              <Col sm={4}>
                <div className="mt-4 mt-sm-0">
                  <p className="mb-2 text-muted text-truncate">
                    <i className="mdi mdi-circle text-success font-size-10 me-1"></i>{" "}
                    Previous Year :
                  </p>
                  <div className="d-inline-flex">
                    <h5 className="mb-0">
                      {formatSar(revenue?.previousYear?.amount)}
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default RevenueAnalytics;
